module.exports = __webpack_public_path__ + "img/mobile/PaytableContent-page_1/ankh@1.5x.png?1.0.6";